<template>
  <div
    v-if="!hidden && abTesting && showComponent"
    :id="anchor"
    :ref="anchor"
    :class="rowClass"
    :style="{
      backgroundImage: backgroundImage ? 'url(' + backgroundImage.src + ')' : '',
      paddingTop: paddingTop >= 0 ? paddingTop + 'px' : '',
      paddingBottom: paddingBottom >= 0 ? paddingBottom + 'px' : '',
    }"
  >
    <div class="l-container">
      <div
        class="c-row__content"
      >
        <h2
          v-if="title"
          class="u-text-align-center c-row__title"
          :class="titleClass"
        >
          {{ title }}
        </h2>
        <h3
          v-if="subtitle"
          class="u-text-align-center c-row__subtitle"
          :class="subtitleClass"
          :style="{ fontFamily: subtitleFont }"
        >
          {{ subtitle }}
        </h3>
        <wysiwyg
          v-if="description"
          :paragraph-size="descriptionTypography"
          :class="descriptionClass"
          :html="description"
        />
        <div :class="cardBoundaryClass">
          <div
            v-if="middleImage"
            class="c-row__middleImage"
            :style="{
              backgroundImage: 'url(' + middleImage + ')',
              paddingTop: paddingTop + 'px',
              paddingBottom: paddingBottom + 'px',
            }"
          />
          <div
            v-if="column"
            :class="gridColumns"
            :style="{ gridGap: columnSpacing + 'px' }"
          >
            <template v-for="col in column">
              <column
                :key="col.id"
                :column="col.data"
                :number-of-columns="amountOfColumns"
                v-bind="col.data"
                :get-product-function="getProductFunction"
                @hideRow="hideRow"
              />
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Column from "./Column";
import Wysiwyg from "../wysiwyg/Wysiwyg";
import isMobile from '@mixins/isMobile';
import { UrlFilters } from '@mixins/cdnMixins'
export default {
  name: 'Row',
  components: {
    Column,
    Wysiwyg
  },
  mixins: [
    //this.isMobile is true screen width < 900px
    isMobile,
    UrlFilters
  ],
  props: {
    textAlignment: {
      type: String,
      default: "center"
    },
    mobileTextAlignment: {
      type: String,
      default: "center"
    },
    anchor: {
      type: String,
      default: ""
    },
    column: {
      type: Array,
      default: null
    },
    numberOfColumns: {
      type: Number,
      default: 1
    },
    title: {
      type: String,
      default: null
    },
    titleTypography: {
      type: String,
      default: "t-heading-3"
    },
    titleMarginBottom: {
      type: String,
      default: "x-small"
    },
    titleColor: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: null
    },
    subtitleTypography: {
      type: String,
      default: "t-heading-3"
    },
    subtitleMarginBottom: {
      type: String,
      default: "x-small"
    },
    subtitleColor: {
      type: String,
      default: ""
    },
    subtitleFont: {
      type: String,
      default: "Poppins"
    },
    description: {
      type: String,
      default: null
    },
    descriptionTypography: {
      type: String,
      default: "t-paragraph"
    },
    descriptionMarginBottom: {
      type: String,
      default: "x-small"
    },
    descriptionColor: {
      type: String,
      default: ""
    },
    backgroundColor: {
      type: String,
      default: null
    },
    cardBoundary: {
      type: Boolean,
      default: false,
    },
    desktopBackgroundImage: {
      type: Object,
      default: undefined
    },
    backgroundSize: {
      type: String,
      default: 'cover'
    },
    mobileBackgroundImage: {
      type: Object,
      default: undefined
    },
    mobileAndDesktopHidden: {
      type: String,
      default: null
    },
    paddingTop: {
      type: [String,Number],
      default: null,
    },
    paddingBottom: {
      type: [String,Number],
      default: null,
    },
    columnSpacing: {
      type: Number,
      default: null,
    },
    getProductFunction: {
      type: Function,
      required: true
    },
    runAbTest: {
      type: Boolean,
      default: false
    },
    abTestName: {
      type: String,
      default: ''
    },
    abTestVariant: {
      type: String,
      default: ''
    },
    columnAlign: {
      type: String,
      default: 'center'
    },
    middleImage: {
      type: String,
      default: null
    }
  },

  data: function() {
    return {
      showComponent: true,
    }
  },

  computed: {
    amountOfColumns(){
      let numberOfColumns = this.numberOfColumns;
      return numberOfColumns;
    },
    gridColumns() {
      let numberOfColumns = this.numberOfColumns;
      var modifier = '';
      if (numberOfColumns > 1) {
        modifier = ' l-grid--' + numberOfColumns + '-col';
      }
      modifier += ' l-grid--align-' + this.columnAlign;
      return 'l-grid' + modifier;
    },
    rowClass() {
      let backgroundClass = "";
      if (this.backgroundColor != "base"); {
        backgroundClass = " u-background-color-" + this.backgroundColor;
      }
      return "c-row" + backgroundClass;
    },
    cardBoundaryClass() {
      if (this.cardBoundary) {
        return "c-row__card-boundary"
      } else
        return ""
    },
    titleClass() {
      let results = ['']
      results.push(this.titleTypography);
      if (this.titleColor) {
        results.push(this.titleTypography + '--' + this.titleColor);
      }
      if(this.subtitle || this.description || this.column) {
        results.push('u-margin-bottom-' + this.titleMarginBottom);
      }
      if (this.isMobile) {
        if (this.mobileTextAlignment) {
          results.push("u-text-align-" + this.mobileTextAlignment)
        }
      } else {
        results.push("u-text-align-" + this.textAlignment)
      }
      return results;
    },
    subtitleClass() {
      let results = ['']
      if(this.subtitleTypography){
        results.push(this.subtitleTypography);
      }
      else {
        results.push('t-heading-6')
      }
      if (this.subtitleColor) {
        results.push(this.subtitleTypography + '--' + this.subtitleColor);
      }
      if(this.description || this.column) {
        results.push('u-margin-bottom-' + this.subtitleMarginBottom);
      }
      if (this.isMobile) {
        if (this.mobileTextAlignment) {
          results.push("u-text-align-" + this.mobileTextAlignment)
        }
      } else {
        results.push("u-text-align-" + this.textAlignment)
      }

      return results;
    },
    descriptionClass() {
      let results = ['']
      if (this.descriptionColor) {
        results.push('u-foreground-' + this.descriptionColor);
      }
      if(this.column) {
        results.push('u-margin-bottom-' + this.descriptionMarginBottom);
      }
      if (this.isMobile) {
        if (this.mobileTextAlignment) {
          results.push("u-text-align-" + this.mobileTextAlignment)
        }
      } else {
        results.push("u-text-align-" + this.textAlignment)
      }
      return results;
    },
    backgroundImage() {
      const isMobile = this.isMobile
      let mobileBackgroundImage = this.mobileBackgroundImage;
      let desktopBackgroundImage = this.desktopBackgroundImage;
      let result = null
      if (mobileBackgroundImage && isMobile) {
        result = mobileBackgroundImage
      } else if (desktopBackgroundImage) {
        result = desktopBackgroundImage
      }
      return (result && result.src)
        ? { ...result, src: this.$getImgUrl(result.src) }
        : null
    },
    hidden() {
      if(this.isMobile && this.mobileAndDesktopHidden == 'mobileHidden' ||
          !this.isMobile && this.mobileAndDesktopHidden == 'desktopHidden') {
        return true;
      }
      else {
        return false;
      }
    },
    abTesting() {
      let runAbTest = this.runAbTest;
      let abTestName = this.abTestName;
      let abTestVariant = this.abTestVariant;
      let $exp = this.$exp;
      return (!runAbTest ||
          runAbTest &&
          $exp &&
          $exp.name == abTestName &&
          $exp.$activeVariants[0].name == abTestVariant);
    },
  },
  mounted () {
    const hash = this.$route.hash.slice(1)
    if(hash) {
      setTimeout(() => {
        try {
          this.$refs[hash].scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
        } catch (error) {
          console.warn(`[Row Anchor] - ${error}`);
        }
      }, 2000);
    }
  },
  methods: {
    hideRow() {
      this.showComponent = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.c-row {
  padding: $section-padding;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  &__content {
    margin: auto;
  }

  &__title {
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: 58px;
    text-transform: uppercase;
  }

  &__subtitle {
    max-width: rem(900px);
    margin-left: auto;
    margin-right: auto;
    font-feature-settings: 'liga' off;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 25px;
  }

  &__middleImage {
    width: 694px;
    height: 280px;
    background-repeat: no-repeat;
    background-size: contain;
    margin: auto;
    overflow: hidden;
    @media screen and (max-width: 693px){
      aspect-ratio: 694/280;
      width: 100vw;
      height: auto;
    }
  }

  &__card-boundary {
    max-width: rem(1000px);
    box-shadow: $box-shadow;
    border-radius: $border-radius;
    padding: rem(50px) rem(100px) rem(80px);
    margin: auto;
    background-color: #ffffff;
  }
}
</style>
